import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { lighten, useTheme } from '@mui/material/styles'
import { FormSectionProps } from '../../interfaces/form'
import { useForm } from 'react-final-form'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

import FormWizard from '../wizard'
import FormRadio from '../../components/FormRadio'
// import theme from '../../theme'

const radioStyle = {
  paddingBottom: 0,
  display: 'none',
}

const textStyle = {
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 4,
  display: 'inline-flex',
  // border: `1px solid ${theme.palette.primary.main}`,
  marginTop: 0,
  marginRight: 6,
  marginBottom: 10,
  fontWeight: 'bold',
  verticalAlign: 'top',
  width: '100%',
  height: '100%',
  minHeight: 80,
  cursor: 'pointer',
  // backgroundColor: lighten(theme.palette.primary.main, 0.8),
}

const PartnerCoverage = ({ validate }: FormSectionProps) => {
  const form = useForm()
  const theme = useTheme()

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        <FormWizard.Page validate={validate}>
          <Typography variant="h3" sx={{ mb: 2 }}>
            Do you want to look at cover for you and your partner?
          </Typography>
          <Grid container spacing={2} sx={{ mb: 14 }}>
            <Grid item xs={12} md={6}>
              <label
                htmlFor="isPartnerCovered-yes"
                style={{ textAlign: 'center' }}
              >
                <FormRadio
                  id="isPartnerCovered-yes"
                  name="isPartnerCovered"
                  value={'true'}
                  style={radioStyle}
                  overrideMuiStyle={{
                    '&.MuiRadio-root': {
                      '&.Mui-checked + span': {
                        backgroundColor: `${theme.palette.primary.main} !important`,
                        color: '#FFF !important',
                      },
                    },
                  }}
                  onClick={async () => {
                    form.change('isPartnerCovered', 'true')
                    await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  style={{
                    ...textStyle,
                    border: `1px solid ${theme.palette.primary.main}`,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Yes
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label
                htmlFor="isPartnerCovered-no"
                style={{ textAlign: 'center' }}
              >
                <FormRadio
                  id="isPartnerCovered-no"
                  name="isPartnerCovered"
                  value={'false'}
                  style={radioStyle}
                  overrideMuiStyle={{
                    '&.MuiRadio-root': {
                      '&.Mui-checked + span': {
                        backgroundColor: `${theme.palette.primary.main} !important`,
                        color: '#FFF !important',
                      },
                    },
                  }}
                  onClick={async () => {
                    form.change('isPartnerCovered', 'false')
                    await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  style={{
                    ...textStyle,
                    border: `1px solid ${theme.palette.primary.main}`,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  No
                </Typography>
              </label>
            </Grid>
          </Grid>
        </FormWizard.Page>
      </Box>
    </Container>
  )
}

export default PartnerCoverage
